module.exports = __webpack_public_path__ + "img/frame (106).a19823f9.jpg";